import React from 'react';
import cn from 'classnames';
import { format } from 'date-fns';

import { CertificateTemplate } from '@lt/components/icons-react/gift_certificate';
import { formatCurrency } from '../../../../utils/stringUtils';
import { NEW_CERTIFICATE_BACKGROUNDS } from '../../store/certificate/constants';
import type { NEW_CERTIFICATE_DESIGNS } from '../../store/certificate/constants';

import styles from './certificate.module.css';

interface ICertificate {
  className?: string;
  isPreview?: boolean;
  isExample?: boolean;
  holder?: string;
  text?: string;
  value?: number;
  width: number;
  design: (typeof NEW_CERTIFICATE_DESIGNS)[keyof typeof NEW_CERTIFICATE_DESIGNS];
}

const Certificate = ({
  className,
  isPreview,
  isExample,
  width,
  value,
  holder,
  text,
  design,
}: ICertificate) => {
  const containerStyles = {
    '--height': `${Math.sqrt(2) * width}px`,
    '--width': `${width}px`,
    '--bgColor': NEW_CERTIFICATE_BACKGROUNDS[design],
  } as React.CSSProperties;

  const oneYearFromNowDate = new Date().setFullYear(
    new Date().getFullYear() + 1,
  );

  return (
    <div className={cn(styles.certificate, className)} style={containerStyles}>
      <div className={cn(styles.certificateContent)}>
        <CertificateTemplate className={cn(styles.certificateTemplate)} />
        {!isPreview && (
          <div className={cn(styles.certificateSvgWrapper)}>
            <svg
              viewBox="0 0 240 340"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
            >
              <foreignObject
                className={cn(styles.certificateForeignObject)}
                x="10"
                y="110"
                width="220px"
                height="15%"
              >
                {!!value && (
                  <div className={cn(styles.certificateValue)}>
                    {formatCurrency(value)}
                  </div>
                )}
              </foreignObject>
              <foreignObject
                className={cn(styles.certificateForeignObject)}
                x="10"
                y="155"
                width="220px"
                height="50px"
              >
                {!!holder && (
                  <div className={cn(styles.certificateHolderWrapper)}>
                    <div className={cn(styles.certificateHolder)}>{holder}</div>
                  </div>
                )}
              </foreignObject>
              <foreignObject
                className={cn(styles.certificateForeignObject)}
                x="10"
                y="205"
                width="220px"
                height="30%"
              >
                {!!text && (
                  <div className={cn(styles.certificateText)}>{text}</div>
                )}
              </foreignObject>
              <foreignObject
                className={cn(styles.certificateForeignObject)}
                x="10"
                y="275"
                width="220px"
                height="10%"
              >
                {isExample && (
                  <div className={cn(styles.certificatePromoExample)}>
                    ПРОМОКОД
                  </div>
                )}
              </foreignObject>
              <foreignObject
                className={cn(styles.certificateForeignObject)}
                x="10"
                y="312"
                width="220px"
                height="5%"
              >
                <div className={cn(styles.certificateFooterText)}>
                  Сертификат действует до{' '}
                  {format(oneYearFromNowDate, 'dd.MM.yyyy')}. Используйте его
                  при бронировании тура <br />
                  или отеля на Level.Travel — просто введите код в поле
                  «Промокод или сертификат»
                  <br /> на этапе оплаты.
                </div>
              </foreignObject>
            </svg>
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(Certificate);
